import { useEffect, useRef } from 'react';
import { useConsentContextOptional } from '@/components/providers/ConsentProvider';
import type { BankAccountSummary } from '@/types/accounts';

/**
 * Applies the account list a successful access renewal fetched to a page's own copy of the
 * accounts, so the renewed account stops showing Access needed without a reload (FIN-885). A
 * renewal that finished before this page mounted is ignored: the page's own load is newer.
 *
 * `apply` must be stable (a state setter).
 */
export function useAccountsAfterRenewal(apply: (accounts: BankAccountSummary[]) => void): void {
  const renewedAccounts = useConsentContextOptional()?.renewedAccounts ?? null;
  const seenAtMount = useRef(renewedAccounts);

  useEffect(() => {
    if (!renewedAccounts || renewedAccounts === seenAtMount.current) return;
    apply(renewedAccounts);
  }, [renewedAccounts, apply]);
}
